import {
  Behaviour,
  serializable,
  LookAtConstraint,
  RawImage,
  Camera,
  GameObject,
  Animator,
  SmoothFollow,
} from "@needle-tools/engine";
import { AnimatorManager } from "./AnimatorManager";
import { Object3D, Vector3 } from "three";
import { UIManager } from "./UIManager";
import { GameSettings } from "./GameSettings";
import { RaceOrderManager } from "./RaceOrderManager";
import config from "../../../newProject/game.config.json"

/*
 * This class handles swapping cameras based on user input
 */
export class CameraManager extends Behaviour {
  private currentBroadcastCamera?: Camera;

  @serializable(UIManager)
  public uiManager?: UIManager;

  private horseCamDefaultPosition: Vector3 = new Vector3(0, 0.1489, -0.029); //for horse racing new Vector3(0.0, 2.29, -0.755); //TODO Refactor entirely

  @serializable(Camera)
  public freeCamera?: Camera;

  @serializable(LookAtConstraint)
  public lookAtConstraint?: LookAtConstraint; //for main camera

  @serializable(Camera)
  public horseCameras?: Camera[];

  @serializable(Camera)
  public mainCamera?: Camera;

  @serializable(Camera)
  public broadcastCameras?: Camera[];

  @serializable(GameObject)
  public smoothFollowObject?: GameObject;

  private broadcastCameraIndex: number = 0;
  private broadcastCameraActive: boolean = false;

  private lookAtIndex: number = 0;
  private racers?: Animator[];
  private animatorManager?: AnimatorManager | null = null;




  @serializable(GameObject)
  public camerasToCycle? : GameObject[];

  awake() {
    this.animatorManager = GameObject.findObjectOfType(AnimatorManager);
    this.racers = this.animatorManager?.returnRacerAnimators();
    this.currentBroadcastCamera = this.broadcastCameras![0];

    
  }

  start(): void {
    if(config.sportSubType === "HR")
    {
  this.horseCamDefaultPosition = new Vector3(0, 2.29, -0.029); //for horse racing new Vector3(0.0, 2.29, -0.755); //TODO Refactor entirely
    }

    if(config.sportSubType === "CR")
      {
    this.horseCamDefaultPosition = new Vector3(0, 2.844, -0.13); //for camel racing
      }

  }

  public activateCamera(cameraToActivate: Camera): void {
    GameObject.setActive(cameraToActivate.gameObject, true);

    if (cameraToActivate != this.freeCamera) {
      GameObject.setActive(this.freeCamera!.gameObject, false);
    }

    //Note - Redo this to be more efficient. This is a hacky way to do it
    this.horseCameras?.forEach((element) => {
      GameObject.setActive(element.gameObject, false);
    });

    GameObject.setActive(this.mainCamera!.gameObject, false);
  }

  public ReturnIsFreeCamActive(): boolean {
    return this.freeCamera!.gameObject.activeSelf;
  }

  public updateCurrentBroadcastCamera(currentCam: Camera): void {
    this.currentBroadcastCamera = currentCam;
  }

  public activateBroadcastCamera(): void {
    this.broadcastCameraActive = !this.broadcastCameraActive;

    if (this.broadcastCameraActive) {
      this.activateCamera(this.currentBroadcastCamera!);
      this.uiManager?.resetHorseFocusText();
      //RaceOrderManager.getInstance().ToggleAllSteeringWheels(false);
    } else {
      this.lookAtIndex = this.racers!.length; //Hacky way of setting the camera to focus on the last racer so it will auto reset to the first via the next line
      this.changeCameraTarget(true);
    }
    //this.uiManager?.toggleAutoCam(this.broadcastCameraActive);
  }

  public ReturnBroadcastCameraActive(): boolean {
    return this.broadcastCameraActive;
  }

  /*
  Toggles the relevant horse cam on and off
  */
  public toggleHorseCamera(cameraPosition: number): void {
    this.broadcastCameraActive = false;

    GameObject.setActive(this.freeCamera!.gameObject, false);

    if (this.mainCamera != null && this.horseCameras != null) {
      GameObject.setActive(this.mainCamera.gameObject, false);

      for (let i = 0; i < this.horseCameras.length; i++) {
        if (i == cameraPosition) {
          GameObject.setActive(this.horseCameras[i].gameObject, true);

          //reset the camera position
          this.horseCameras[i].gameObject.position.set(
            this.horseCamDefaultPosition.x,
            this.horseCamDefaultPosition.y,
            this.horseCamDefaultPosition.z,
          );
        } else {
          GameObject.setActive(this.horseCameras[i].gameObject, false);
        }
      }
    }
  }

  public focusOnRacerJS(index: number) {
    this.broadcastCameraActive = false;
    if (this.mainCamera != null && this.horseCameras != null) {
      GameObject.setActive(this.mainCamera.gameObject, false);

      //set the camera target to the racer
      for (let i = 0; i < this.horseCameras.length; i++) {
        if (i == index) {

          GameObject.setActive(this.horseCameras[i].gameObject, true);
           RaceOrderManager.getInstance().HandleRacerWheelSpin(index);
           RaceOrderManager.getInstance().ToggleSteeringWheelsBarActive(this.horseCameras[i].gameObject.name);

          //reset the rotation of the camera
          this.horseCameras[i].gameObject.quaternion.set(0, 1, 0, 0);

          //reset the camera position
          this.horseCameras[i].gameObject.position.set(
            this.horseCamDefaultPosition.x,
            this.horseCamDefaultPosition.y,
            this.horseCamDefaultPosition.z,
          );

          /**
           * Added the two lines below so when when driver cam is active, the text for the carousel is updated and using the carousel will always result in
           * focusing on race leader
           */
          this.uiManager?.resetHorseFocusText();
          this.lookAtIndex = this.racers!.length; //Hacky way of setting the camera to focus on the last racer so it will auto reset to the first via the next line
          
         

        } else {
          GameObject.setActive(this.horseCameras[i].gameObject, false);
        }
      }
    }
  }

  public focusOnRacer(racerImage: RawImage): void {
    this.broadcastCameraActive = false;
    if (this.mainCamera != null && this.horseCameras != null) {
      GameObject.setActive(this.mainCamera.gameObject, false);

      //get the texture name of the image. This will be a number 1-6
      var textureName = racerImage.mainTexture!.name;

      //get the racer number from the texture name
      var racerNumber = RaceOrderManager.getInstance().racers.find(
        (racer) => racer.racerName == textureName,
      )?.racerNumber;

      //get the racer index from the racer number
      var racerIndex = parseInt(racerNumber) - 1;

      //set the camera target to the racer
      for (let i = 0; i < this.horseCameras.length; i++) {
        if (i == racerIndex) {
          GameObject.setActive(this.horseCameras[i].gameObject, true);
          //reset the camera position
          this.horseCameras[i].gameObject.position.set(
            this.horseCamDefaultPosition.x,
            this.horseCamDefaultPosition.y,
            this.horseCamDefaultPosition.z,
          );

          // this.uiManager?.resetHorseFocusText();
        } else {
          GameObject.setActive(this.horseCameras[i].gameObject, false);
        }
      }
    }
  }

  public resetCameraLookAtIndex(): void {
    this.lookAtIndex = this.horseCameras!.length;
    this.changeCameraTarget(true);
  }

  // public changeCameraTarget(changePositive: boolean): void {
  //   console.log("Changing camera target");
  //   console.log("horseCameras length is " + this.horseCameras!.length);
  //   this.broadcastCameraActive = false;
  //   if (this.lookAtConstraint?.sources != null && this.racers != null) {
  //     //set all horse cameras inactive
  //     for (let i = 0; i < this.horseCameras!.length; i++) {
  //       GameObject.setActive(this.horseCameras![i].gameObject, false);
  //     }

  //     GameObject.setActive(this.freeCamera!.gameObject, false);

  //     //set main camera active
  //     GameObject.setActive(this.mainCamera!.gameObject, true);

  //     if (changePositive) {
  //       this.lookAtIndex++;
  //     } else {
  //       this.lookAtIndex--;
  //     }

  //     if (this.lookAtIndex >= this.racers.length) {
  //       this.lookAtIndex = 0;
  //     }

  //     if (this.lookAtIndex < 0) {
  //       this.lookAtIndex = this.racers.length - 1;
  //     }

  //     const gameSettings = GameSettings.getInstance();
  //     const currentTargetTransform =
  //       this.racers[this.lookAtIndex].gameObject;

  //     const smoothFollow = this.smoothFollowObject?.getComponent(SmoothFollow);
  //     if (
  //       gameSettings.cameraSettings.useSmoothCameraTransitions &&
  //       smoothFollow
  //     ) {
  //       smoothFollow.target = currentTargetTransform;
  //     } else {
  //       this.lookAtConstraint.sources[0] = currentTargetTransform;
  //     }

  //     this.uiManager?.updateHorseFocusText(
  //       this.racers[this.lookAtIndex].gameObject.name,
  //     );
  //   }
  // }

  /*
   * This function changes the camera target
   */
  public changeCameraTarget(changePositive: boolean): void {
    console.log("Changing camera target");
    console.log("horseCameras length is " + this.horseCameras!.length);
    this.broadcastCameraActive = false;
    if (this.racers != null) {
      //set all horse cameras inactive
      for (let i = 0; i < this.camerasToCycle!.length; i++) {
        GameObject.setActive(this.camerasToCycle![i], false);
      }

      GameObject.setActive(this.freeCamera!.gameObject, false);


      if (changePositive) {
        this.lookAtIndex++;
      } else {
        this.lookAtIndex--;
      }

      if (this.lookAtIndex >= this.camerasToCycle!.length) {
        this.lookAtIndex = 0;
      }

      if (this.lookAtIndex < 0) {
        this.lookAtIndex = this.camerasToCycle!.length - 1;
      }

      GameObject.setActive(this.camerasToCycle![this.lookAtIndex], true);

      this.uiManager?.updateHorseFocusText(
        this.camerasToCycle![this.lookAtIndex].name
      );
    }

    //RaceOrderManager.getInstance().ToggleAllSteeringWheels(false);
  }
}
